let superSearchAjax;

async function superSearch(query, page = undefined) {
    console.log('superSearch', { query, page });
    return new Promise((resolve) => {
        const $ = jQuery.noConflict();
        let url = `/api/superSearch?query=${query}`;
        if (page !== undefined) {
            url += '&page=' + page;
        }
        if (superSearchAjax !== undefined) {
            superSearchAjax.abort();
        }
        superSearchAjax = $.get(url);
        superSearchAjax.done((data) => {
            resolve(data);
        });
    });
}

function groupSuperSearchResults(data) {
    const types = {
        'Company': {
            name: 'Bedrijven',
            openFn: (row) => {
                view_company(row.searchable_id);
            },
        },
        'Contact': {
            name: 'Personen',
            openFn: (row) => {
                view_contact(row.searchable_id);
            },
        },
        'Entry': {
            name: 'API Aanmeldingen',
            openFn: () => {
                view_entries();
            },
        },
        'Course': {
            name: 'Cursussen',
            openFn: (row) => {
                view_course(row.searchable_id);
            },
        },
        'Product': {
            name: 'Artikelen',
            openFn: (row) => {
                view_product(row.searchable_id);
            },
        },
        'ProductCategory': {
            name: 'Artikelcategorieën',
            openFn: (row) => {
                view_product_category(row.searchable_id);
            }
        },
        'Appointment': {
            name: 'Planningen',
            openFn: (row) => {
                view_appointment(row.searchable_id);
            }
        },
        'Device': {
            name: 'Apparatuur',
            openFn: (row) => {
                view_device(row.searchable_id);
            }
        },
        'DeviceCategory': {
            name: 'Apparatuurcategorieën',
            openFn: (row) => {
                view_device_category(row.searchable_id);
            }
        },
        'Evaluation': {
            name: 'Evaluaties',
            openFn: (row) => {
                view_evaluation(row.searchable_id);
            }
        },
        'Quotation': {
            name: 'Offertes',
            openFn: (row) => {
                view_quotation(row.searchable_id);
            }
        },
        'Order': {
            name: 'Orders',
            openFn: (row) => {
                view_order(row.searchable_id);
            }
        },
        'Invoice': {
            name: 'Facturen',
            openFn: (row) => {
                view_invoice(row.searchable_id);
            }
        },
    }
    return Object.keys(types)
        .map(type => {
            return {
                type,
                name: types[type].name,
                openFn: types[type].openFn,
                data: data.filter(item => item.searchable_type === type)
            };
        })
        .filter(item => item.data.length > 0);
}

function getFieldName(type, field) {
    const key = `${type}.${field}`;
    const fields = {
        'Company.name': 'Bedrijfsnaam',
    'Company.client_id': 'Debiteurnummer',
    'Company.invoice_email': 'Factuur e-mailadres',
    'Company.coc_no': 'KvK nummer',
    'Contact.client_id': 'Debiteurnummer',
    'Contact.email': 'E-mailadres',
    'Contact.last_name': 'Achternaam',
    'Contact.last_name_with_prefix': 'Naam',
    'Contact.last_name_with_prefix_and_initials': 'Naam',
    'Contact.first_name': 'Voornaam',
    'Entry.data_company_name': 'Bedrijfsnaam',
    'Entry.data_contact_email': 'E-mailadres',
    'Entry.data_contact_last_name': 'Achternaam',
    'Entry.data_contact_last_name_with_prefix': 'Naam',
    'Entry.data_contact_last_name_with_prefix_and_initials': 'Naam',
    'Entry.data_contact_first_name': 'Voornaam',
    'Course.description': 'Omschrijving',
    'Product.name': 'Naam',
    'ProductCategory.name': 'Naam',
    'Appointment.appointment_group_id': 'Planningsnummer',
    'Device.serial_number': 'Serienummer',
    'DeviceCategory.name': 'Naam',
    'Evaluation.name': 'Naam',
    'Quotation.uid': 'Offertenummer',
    'Order.uid': 'Ordernummer',
    'Invoice.uid': 'Factuurnummer',
    }
    if (fields.hasOwnProperty(key)) {
        return fields[key];
    }
    return field;
}

jQuery(document).ready(function ($) {
    let debouncedFn, query, page;


    const wrapper = $('.super-search-wrapper');
    if (wrapper.length === 0) return;
    const searchBar = $('#super-search-bar');
    const resultsWrapper = $('.super-search-results-wrapper ul');
    const resultsContainer = resultsWrapper.parent();

    const loadResults = async () => {
        if (query.length === 0) return;
        const result = await superSearch(query, page);
        console.log({ page, result });
        // data = [...(data ? data : {}), ...result.data];
        renderResults(groupSuperSearchResults(result.data), result.last_page > page);
    }
    const loadMoreResults = async () => {
        page++;
        await loadResults();
    }
    const closeSearchBar = () => {
        wrapper.removeClass('open');
    }
    const renderResults = (data, hasMore) => {
        if (page === 1) {
            resultsWrapper.empty();
            if (data.length === 0) {
                resultsWrapper.append('<li><span>Geen resultaten gevonden</span></li>');
                return;
            }
        }
        data.forEach(item => {
            const name = item.name;
            let groupLi = $(`li[data-name="${name}"]`);
            if (groupLi.length === 0) {
                groupLi = $('<li />');
                groupLi.attr('data-name', name);
                groupLi.append(`<span>${name}</span>`);
                resultsWrapper.append(groupLi);
                groupLi.append('<ul />');
            }
            const groupUl = groupLi.children('ul');
            item.data.forEach(result => {
                const li = $('<li />');
                const a = $('<a />');
                let rowName = result.name;
                if (!rowName) {
                    rowName = result.value;
                }
                a.click(function (e) {
                    e.preventDefault();
                    closeSearchBar();
                    item.openFn(result);
                })
                a.html(rowName);
                li.append(a);
                const small = $('<small />');

                // mark the part of the string that matches the query within a span
                const regex = new RegExp(query, 'gi');
                const marked = result.value.replace(regex, (match) => `<span class="highlight">${match}</span>`);
                small.html(`${getFieldName(result.searchable_type, result.searchable_field)}: `);
                small.append(marked);
                a.append(small);
                groupUl.append(li);
            });
        });
        if (hasMore) {
            const loadMoreLi = $('<li class="more-button-li" />');
            const loadMoreA = $('<a class="load-more-button" />');
            loadMoreA.click(async function (e) {
                e.preventDefault();
                loadMoreLi.isLoading();
                await loadMoreResults();
                loadMoreLi.remove();
            })
            loadMoreA.html('Laad meer resultaten...');
            loadMoreLi.append(loadMoreA);
            resultsWrapper.append(loadMoreLi);
        } else {
            resultsWrapper.find('.more-button-li').remove();
        }
    }
    searchBar.on('focus', () => {
        searchBar.select();
        wrapper.addClass('open');
    });

    document.addEventListener('pointerdown', function (event) {
        let isClickInside = wrapper[0].contains(event.target);
        if (!isClickInside) {
            closeSearchBar();
        }
    });

    searchBar.on('keyup', async function () {
        if (debouncedFn !== undefined) debouncedFn.cancel();
        query = $(this).val().trim();
        if (query.length === 0) {
            resultsContainer.doneLoading();
        } else {
            if (!resultsContainer.is('[data-is-loading]')) {
                resultsWrapper.empty();
                resultsContainer.scrollTop(0);
                resultsContainer.isLoading();
            }
        }
        debouncedFn = _.debounce(async () => {
            page = 1;
            // data = [];
            await loadResults(query);
            resultsContainer.doneLoading();
        }, 500);
        debouncedFn();
    });
});
